// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".titleLineBreak[data-v-3190baa0]{-webkit-line-clamp:2}.bodyLineBreak[data-v-3190baa0],.titleLineBreak[data-v-3190baa0]{display:-webkit-box;-webkit-box-orient:vertical;overflow:hidden}.bodyLineBreak[data-v-3190baa0]{-webkit-line-clamp:3}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
